import { Banner } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function MarketplaceBetaBanner() {
  const { t } = useTranslation();

  return (
    <Banner
      data-testid="marketplace-beta-banner"
      icon="circle-info"
      title={t("marketplace.betaBannerTitle", {
        defaultValue:
          "This Marketplace Beta is an interactive experience designed to evolve quickly based on customer feedback.",
      })}
      description={t("marketplace.betaBannerBody", {
        defaultValue:
          "We'll use your input to help shape future Marketplace capabilities.",
      })}
    />
  );
}
